import { devices } from "src/utils/styled/_variables.styled";
import styled from "styled-components";

interface BannerContainerProps {
	backgroundColor: string;
	colorParagraph: string;
}

interface ImageContainerProps {
	backgroundImage: string;
}

function handleBackground(props: any) {
	return props.backgroundColor || "transparent";
}

function handleBackgroundImage(props: any) {
	if (props.backgroundImage) {
		return `url("${props.backgroundImage}") no-repeat bottom`;
	}
	return "transparent";
}

export const ImageContainer = styled.div<ImageContainerProps>`
	background: ${(props) => handleBackgroundImage(props)};
	background-size: contain;
	width: 48.9%;

	@media only screen and (min-width: 1023px) and (max-width: 1060px) {
		width: 48.5%;
	}

	@media ${devices.tablet} {
		width: 52.5%;
	}

	@media ${devices.mobile} {
		display: none;
	}
`;

export const BannerContainer = styled.section<BannerContainerProps>`
	background: ${(props) => handleBackground(props)};
	padding: 0px 154px 0 154px;
	min-height: 560px;
	height: auto;
	display: flex;
	flex-direction: row;
	gap: 50px;

	@media only screen and (min-width: 1023px) and (max-width: 1025px) {
		height: auto;
		min-height: 560px;
		padding: 0 121px 0 121px;
	}

	@media ${devices.tablet} {
		height: auto;
		min-height: 560px;
		padding: 0 121px 0 121px;
	}

	@media ${devices.mobile} {
		height: auto;
		min-height: auto;
		padding: 24px 24px 24px 24px;
	}

	.bannerImg__mobile {
		max-width: 100%;
		max-height: 450px;
	}

	.banner-logo-left-side {
		width: 48.9%;
		display: flex;
		flex-direction: column;
		gap: 13px;
		padding-top: 40px;
		padding-bottom: 40px;

		@media only screen and (min-width: 1023px) and (max-width: 1025px) {
			width: 48.5%;
			padding-top: 40px;
			padding-bottom: 40px;
		}

		@media ${devices.tablet} {
			width: 48.5%;
			padding-top: 40px;
			padding-bottom: 40px;
		}

		@media ${devices.mobile} {
			padding-top: 0px;
			padding-bottom: 0px;
			width: 100%;
		}
	}
	.banner-logo-left-side .banner-logo-img {
		@media ${devices.mobile} {
			padding-top: 0px;
		}
	}
	.banner-logo-left-side .banner-content {
	}
	.banner-logo-left-side h2 {
		font-size: 48px;
		font-weight: 550;

		@media ${devices.mobile} {
			font-size: var(--font-size-lg);
			padding-top: 0px;
		}
	}
	.banner-logo-left-side p {
		font-size: var(--font-size-sm);
		font-weight: 250;
	}
	.banner-logo-left-side li {
		margin-left: -20px;
		font-weight: 250;
	}

	.banner-logo-left-side li::marker {
		color: #${(props) => props.colorParagraph};
	}
`;
